import { type DocumentNode, gql } from '@apollo/client';

/**
 * Ingest transcript input structure
 */
export interface IngestTranscriptInput {
  [key: string]: unknown;
}

/**
 * Variables for updateTranscript mutation
 */
export interface UpdateTranscriptVariables {
  assetId: string;
  transcript: IngestTranscriptInput;
}

/**
 * Transcript update response structure
 */
export interface TranscriptUpdateResponse {
  statusCode: number;
  content: string;
}

/**
 * Update transcript payload structure
 */
export interface UpdateTranscriptPayload {
  response: TranscriptUpdateResponse;
}

/**
 * Response structure for updateTranscript mutation
 */
export interface UpdateTranscriptResponse {
  updateTranscript: UpdateTranscriptPayload;
}

export const updateTranscript: DocumentNode = gql`
  mutation updateTranscript($assetId: ID!, $transcript: IngestTranscriptInput!) {
    updateTranscript(assetId: $assetId, transcript: $transcript) {
      response {
        statusCode
        content
      }
    }
  }
`;

export default updateTranscript;
